<script>
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import { useDynamicUgcStore } from "~/stores/dynamic-ugc-store";

export default {
  name: "CreateArticleButton",
  elementPanelSettings: {
    displayName: "Create Article",
    elementGroup: "general",
  },
  extends: BaseButtonElement,
  computed: {
    shouldRenderButton() {
      return this.editMode || useConfigurationStore().canCreateArticle;
    },
  },
  methods: {
    handleButtonClick() {
      return this.editMode ? null : useDynamicUgcStore().create();
    },
  },
};
</script>
